import { useState } from "react"
import { flushSync } from "react-dom"

import { prefetchQuery } from "../../../../core/api/queryClient"
import { useMatchEnvironment } from "../../../../modules/environment/envHooks"
import { EnvironmentType } from "../../../../modules/environment/envTypes"

import { fetchOrderChatMessages, OrderChatQuery } from "../orderChatApi"

export const PRINT_CHAT_ENVIRONMENTS = [
    EnvironmentType.Local,
    EnvironmentType.Test,
    EnvironmentType.Demo,
    EnvironmentType.QA,
]

export function usePrintWithChatHistory(orderIds: ReadonlyArray<number>) {
    const isPrintChatEnabled = useMatchEnvironment(PRINT_CHAT_ENVIRONMENTS)
    const [isChatHistoryPrinted, setIsChatHistoryPrinted] = useState(false)

    const printWithChatHistory = async () => {
        await Promise.all(
            orderIds.map((orderId) =>
                prefetchQuery(fetchOrderChatMessages, {
                    queryName: OrderChatQuery.MESSAGES,
                    dependencies: { orderId },
                }),
            ),
        )
        window.addEventListener("afterprint", () => setIsChatHistoryPrinted(false), { once: true })
        flushSync(() => setIsChatHistoryPrinted(true))
        window.print()
    }

    return {
        isPrintChatEnabled,
        isChatHistoryPrinted,
        printWithChatHistory: isPrintChatEnabled ? printWithChatHistory : undefined,
    }
}
